// Get window dimensions
export function getWindowDimensions () {
  const width = window.innerWidth
  const height = window.innerHeight
  return { width, height }
}

// Get current scroll position
export function getCurrentScrollPosition () {
  const x = window.pageXOffset
  const y = window.pageYOffset
  return { x, y }
}

export function getScrollOffset (element) {
  return element.offsetParent.offsetTop + element.offsetTop
}

export function scrollTo (scrollId) {
  const scrollElement = document.getElementById(scrollId)

  if (scrollElement) scrollElement.scrollIntoView({ behavior: 'smooth' })
}

export function newWindow (event, category, label, track = true) {
  event.preventDefault()
  window.open(event.currentTarget.href)

  const eventCategory = category || 'link'
  const eventLabel = label || event.currentTarget.href

  if (track) {
    this.trackEvent(eventCategory, 'click', eventLabel)
  }
}

export function takeToAnchor () {
  if (window.location.hash) {
    const hash = window.location.hash

    // Don't attempt parsing if hash contains #! which is what Freshop uses
    if (hash.indexOf('#!') === -1) {
      window.onload = () => {
        document.querySelector(hash).scrollIntoView()
      }
    }
  }
}
